import React, { useState, useEffect } from 'react'
import _ from 'lodash'
import { Label, Button, Row, Col } from 'reactstrap'
import Select from "react-select";
import { useTranslation } from 'react-i18next'
import LoadingOverlay from "react-loading-overlay"

import useFetchStatus from 'customHooks/useFetchStatus'
import { successToast, errorToast } from 'main_views/components/toast'
import { addDoc, updateDoc } from 'dbHandler'
import { updateForm, setFieldValue, getFieldsValues } from 'main_views/form/formHandler'
import i18n from 'utils/translation/i18n'
import DepartmentsAndRolesForm from 'main_views/components/Form/form_v2'
import departmentsAndRolesFields from './departmentsAndRolesFields'

/**
 * show & edit the form gateway staff
 * + 
 * identify the form departments & roles
 *
 */
function GatewayForms(props) {

   let { t } = useTranslation()

   let { selectedFormFields, toggle, updateFormList } = props
   let { id: formId } = selectedFormFields

   let staffQuery = {
      field: 'permissons.CanTakeAction',
      value: true
   }
   let gatewayQuery = {
      field: 'formId',
      value: formId
   }

   let [staffOpts, setStaffOpts] = useState([]) // for the drop list (all staff who can tack an action)
   let [staff, staffError, staffIsLoading] = useFetchStatus(`staff`, {}, [], staffQuery)
   let [formGateway, formGatewayError, formGatewayIsLoading] = useFetchStatus(`gateway`, {}, [], gatewayQuery)
   let [gatewayStaff, setGatewayStaff] = useState([]) // for the drop list (the selected staff)
   let [gatewayId, setGatewayId] = useState('')
   let [loading, setloading] = useState(false)

   // form just for departments & roles inputs
   let [form, setForm] = useState(departmentsAndRolesFields)

   // set all staff (who can tack an actions) for droplist values
   useEffect(() => {
      if (_.isEmpty(staff)) return

      let opts = getStaffOptions(staff)

      setStaffOpts(opts)

   }, [staff])

   // set the form staff  
   useEffect(() => {
      if (_.isEmpty(formGateway) || _.isEmpty(staffOpts)) return

      let formGateValue = _.values(formGateway)

      if (_.isEmpty(formGateValue)) return // the form doesn't have a previous staff

      let gatewayInfo = _.get(formGateValue, `[0]`)

      // set the pre selected staff 
      let ps = _.get(gatewayInfo, `staffs`, [])

      ps = _.map(ps, id => ({
         ..._.find(staffOpts, s => s.innerValue === id),
         value: Math.random()
      }))

      setGatewayStaff(ps) // drop list (selected staff)
      setGatewayId(_.get(gatewayInfo, `id`, []))
      setForm(updateForm(form, gatewayInfo)) // set the departments & roles inputs values

      setloading(false)

   }, [formGateway, staffOpts])


   // set the gateway staff changes
   let setChanges = (selectedStaff) => {
      if (!selectedStaff) return setGatewayStaff([]) // the last staff was deleted

      const newSelectedOption = selectedStaff.map(opt => ({
         ...opt,
         // set a random value because it is needed to be able to delete the value without deleting all of them
         value: Math.random()
      }))

      setGatewayStaff(newSelectedOption)
   }

   // set departments & roles form changes
   let setFormChanges = (stateName, value, className) => {
      setFieldValue(form, stateName, value, className)
      setForm({ ...form }) // to re-render the form 
   }

   // send gateway staff
   let save = async () => {

      if (gatewayStaff.length === 0)
         return errorToast(t('please_select_a_staff'))

      setloading(true)

      try {

         let { departments, roles } = form

         let data = {
            formId,
            staffs: _.map(gatewayStaff, 'innerValue'),
            departments: _.map(departments.value, 'value'),
            roles: _.map(roles.value, 'value'),
         }

         _.isEmpty(gatewayId) ? await addDoc(data, `gateway`) : await updateDoc(data, `gateway/${gatewayId}`)

         updateFormList()
         successToast(t('form_info_was_updated'))
         toggle(false)

      } catch (error) {
         console.log({ error })
         errorToast(t('something_wrong'))

      } finally {
         setloading(false)
      }
   }

   return (
      <div
         style={{ display: 'grid' }}
      >

         <LoadingOverlay
            spinner
            active={staffIsLoading || formGatewayIsLoading}
            text={t('loading')}
            styles={{
               overlay: (base) => ({
                  ...base,
                  background: '#fff',
                  color: '#000'
               }),
               spinner: (base) => ({
                  ...base,
                  // width: 'px',
                  '& svg circle': {
                     stroke: '#000'
                  }
               })
            }}
         >

            <Row>

               <Col md='12' className='py-2'>
                  {/* gateway staffs input */}
                  <Label>{t('select_the_staff_in_order')}</Label>
                  <Select
                     className="react-select info"
                     classNamePrefix="react-select"
                     placeholder={t('select_the_staff')}
                     name="multipleSelect"
                     closeMenuOnSelect={false}
                     isMulti
                     value={gatewayStaff}
                     onChange={setChanges}
                     options={staffOpts}
                  />
                  {_.isEmpty(gatewayStaff) && (
                     <label className='text-mute' style={{ fontSize: 'xx-small' }}>
                        * If the gateway staff wasn't specified, the form will not be visible
                     </label>
                  )}
               </Col>

               <Col md='12'>
                  {/* departments & roles inputs */}
                  <DepartmentsAndRolesForm
                     inputs={form}
                     onChange={setFormChanges}
                  />
               </Col>
            </Row>

            <Button
               color='info'
               className='float-right mt-5'
               disabled={loading}
               onClick={save}>
               {t(loading ? 'loading' : 'save')}
            </Button>

         </LoadingOverlay>

      </div>
   )
}

export default GatewayForms

/**
 *
 *
 * @param {array} staff
 * @returns {array}
 */
function getStaffOptions(staff) {

   let opts = [
      {
         value: "",
         label: i18n.t('select_the_staff_in_order'),
         isDisabled: true,
      },
      { innerValue: "manager", value: Math.random(), label: i18n.t('staff_manager') },
      { innerValue: "supervisor", value: Math.random(), label: i18n.t('staff_supervisors') },
   ]

   let staffNames = _.map(staff, s => ({
      label: s.name_en,
      innerValue: s.id,
      // set a random value because it is needed to be able to delete the value without deleting all of them
      value: Math.random()
   }))

   return [...opts, ...staffNames]
}
